import classNames from "classnames";

import style from "./InfoBadge.module.css";

export const InfoBadge: React.FC<{
  superTitle?: string;
  title?: string;
  description?: string;
  cta?: React.ReactNode;
  standalone?: boolean;
}> = ({ superTitle, title, description, cta, standalone }) => {
  return (
    <div className={classNames(style.container, standalone && style.standalone)}>
      <div className={style.titleContainer}>
        <div className={style.superTitle}>{superTitle}</div>
        <div className={style.title}>{title}</div>
        <div className={style.description}>{description}</div>
      </div>
      <div className={style.cta}>{cta}</div>
    </div>
  );
};
